<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'NpButton',
});
</script>
<template>
  <div
    class="flex"
    :class="[bemClass, props.class]"
    style="padding: 0"
    :style="wrapperStyle"
  >
    <n-spin
      :show="loading"
      :size="14"
      :class="{ 'cursor-wait': loading }"
      class="flex"
    >
      <n-button
        ref="buttonRef"
        style="margin: 0"
        v-bind="$attrs"
        :class="props.class"
        @click="handleClick"
      >
        <template v-if="$slots['icon']" #icon>
          <slot name="icon"></slot>
        </template>
        <slot></slot>
      </n-button>
    </n-spin>
  </div>
</template>

<script lang="ts" setup>
import { useCreate } from '../../_hooks/create'
import { npButtonProps } from './props'
import { NButton, NSpin } from 'naive-ui'
import { throttle } from 'lodash-es'
import { computed, ref, useAttrs, type CSSProperties } from 'vue'
import { run } from '../../utils'

const { bemClass } = useCreate('np-button')



const props = defineProps(npButtonProps)

const emit = defineEmits<{
  (event: 'click', e?: MouseEvent): void
}>()

const wrapperStyle = computed(() => {
  const _style: CSSProperties = {}
  const attrs = useAttrs()
  const { style = {} } = attrs as { style: CSSProperties }
  if (style.width) {
    _style.width = style.width
  }
  return style
})

const loading = ref(false)
let timer: any
const handleClick = throttle(
  (e?: MouseEvent) => {
    if (timer !== undefined) {
      return
    }
    if (props.click !== undefined) {
      timer = setTimeout(() => {
        loading.value = true
      }, 300)
      run(props.click, e)
        .then(() => {})
        .finally(() => {
          clearTimeout(timer)
          timer = undefined
          loading.value = false
        })
    } else {
      emit('click', e)
    }
  },
  350,
  {
    leading: true,
    trailing: false,
  }
)

const buttonRef = ref()
defineExpose(
  new Proxy(
    {},
    {
      get(_, p) {
        if (p === 'click') {
          return handleClick
        }
        return buttonRef.value?.[p]
      },
      has(_, p) {
        if (p === 'click') {
          return true
        }
        return p in buttonRef.value
      },
    }
  )
)
</script>
